module.exports = __webpack_public_path__ + "static/media/review-guide-list.4e5b36f1.png";